import * as React from 'react';
import {getHostApi, getRequestConfig} from "../../../../utils";
import {getUserId} from "../../MonCompteAction";
import {GalleryFile} from "../../iMonCompte";
import {formatDate, formatNumCommande} from "../../OrderAction";
import {useEffect, useState} from "react";
import {UploadBtnByGallery} from "./UploadBtnByGallery";
import {UploadBtnProps} from "./UploadBtn";
import Icons from "../../Icons";
import Modal from "react-responsive-modal";
import {getUploadRequest} from "../UploadActions.api";
import {bgLikeTextile} from "../UploadUtils";

interface ModalGalleryProps {
  infosUpload: UploadBtnProps;
  selectedFile?: GalleryFile;
  orderId: string;
  bgColor: string;
  onSelectedFilesUpdated?(selectedFile: GalleryFile): void;
  lstFiles?: GalleryFile[];
  lstFilesBatAuto?: GalleryFile[];
  lstFilesSansBatAuto?: GalleryFile[];
  isInterne: boolean;
  onDownloadFile?(): void;
}

export const ModalGallery = (props: ModalGalleryProps) => {
  const [selectedFile, setSelectedFile] = useState<GalleryFile>();
  const [displayAlert, setDisplayAlert] = useState<boolean>(false);

  useEffect(() => {
    if(props.selectedFile) {
      setSelectedFile(props.selectedFile);
    }
  }, []);

  function selectFile(event: React.MouseEvent<HTMLDivElement>, file: GalleryFile, withUpload: boolean = true) {
    const mergeInfosFile = {
      ...selectedFile,
      DateDeCommande: file.DateDeCommande,
      creation_id: file.creation_id,
      dimensions: file.dimensions,
      fileNameOrigin: file.fileNameOrigin,
      fromOrderId: file.fromOrderId,
      name: file.name,
      numCommande: file.numCommande,
      path: file.path,
      poids: file.poids,
      surface_id: file.surface_id,
      surfaceEmplacementId: file.surfaceEmplacementId,
      galerieFichierId: file.galerieFichierId,
      galerieFichierVariableId: file.galerieFichierVariableId,
      needReupload: file.needReupload,
      pathFileOrigin: file.pathFileOrigin,
      typeMimeSource: file.typeMimeSource,
      fichierTiff: file.fichierTiff,
      oldTiffFile: file.oldTiffFile
    }
    setSelectedFile(mergeInfosFile as GalleryFile);
    if(!file.isBatAuto && props.isInterne && withUpload) {
      setDisplayAlert(true);
    } else {
      if(props.onSelectedFilesUpdated && withUpload) {
        props.onSelectedFilesUpdated(mergeInfosFile as GalleryFile)
      }
    }
    if(!withUpload) {
      onDownloadFile(false, mergeInfosFile);
    }
  }

  function onDownloadFile(isSource: boolean = true, infosFile: Record<string, unknown> = {}) {
    const fileSelected = selectedFile ?? infosFile as unknown as GalleryFile;
    if(fileSelected) {
      const fichierBase = isSource ? fileSelected.fileNameOrigin : fileSelected.fichierTiff;
      const url = `${getHostApi()}/customers/${getUserId()}/orders/${fileSelected.fromOrderId}/image-files?nom=${fichierBase}&numCommande=${fileSelected.numCommande}&path=/travail.auto/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
      const config = {...getRequestConfig(), responseType: 'blob'};
      getUploadRequest(url, config).then((response: any) => {
        if (response && response.status == 200) {
          const file = new Blob([response.data])
          const imgURL = window.URL.createObjectURL(file);
          const tmpLink = document.createElement('a');
          const nameFile = fileSelected.numCommande.split('-')[2] + "-" + fichierBase;
          tmpLink.href = imgURL;
          tmpLink.setAttribute('download',  nameFile);
          tmpLink.click();
          if(props.onDownloadFile && isSource) {
            props.onDownloadFile();
          }
        }
      });
    }
  }

    /**
     * Retourne la miniature de l'image
     *
     * @param {Image} image
     * @param {string} couleur
     * @returns {any}
     */
    const renderImage = (image: GalleryFile) => {
      const classImg =  props.isInterne ? '' : 'galeryImgClient';
      const styleFibreTextile = bgLikeTextile(props.bgColor, 1, 6, 0.9 );
      const styleDiv = {...styleFibreTextile,  height: '28vh', background: props.bgColor, border: '1px solid #dee2e6', maxHeight: '30vh'};
      const type = props.infosUpload.marquageId == 4 ? "miniatureBroderie": "miniatureTiff";
      return (
        <div className={`d-flex align-items-center border-bottom-0 flex-grow-1 p-4 ${classImg}`}
             style={styleDiv}>
          {props.isInterne && <div className={'d-flex identifiantsFichiersContainer p-2 justify-content-between align-items-center'}>
            <div title={`Identifiant du fichier client : ${image.galerieFichierId}`} className={'cursor-help px-1 bg-info white text-center signatureFileClient signatureFileOrigin '}>{image.galerieFichierId}</div>
          </div>}
          <img src={`${getHostApi()}/customers/${getUserId()}/orders/${props.orderId}/image-files3?numCommande=${image.numCommande}&id=${image.creation_id}&num=${image.surfaceEmplacementId}&type=${type}&xsrf=${localStorage.getItem('xsrfToken')}&miniaBroderie=${image.name}`}
               style={{ maxWidth: '111px', maxHeight: '100%' }} className="mx-auto p-1" />
        </div>
      );
    };

    /**
     * Retourne la date et le numéro d'une commande
     *
     * @returns {any}
     * @param image
     */
    const renderOrderDateAndNum = (image: GalleryFile) => {
      return (
        <p className="small m-0 p-1" style={{fontSize: '11px' }}>
          Utilisé dans la commande <span className="bold">{formatNumCommande(image.numCommande)}</span> du
          &nbsp;{formatDate(image.DateDeCommande.split(' ')[0])}
        </p>
      );
    };

    /**
     * Retourne les dimensions du fichier
     *
     * @returns {any}
     * @param image
     */
    const renderDimensions = (image: GalleryFile) => {
      return (
        <p className="small m-0 p-1 text-center" style={{fontSize: '11px'}}>
          {parseFloat(image?.dimensions?.width).toFixed(2)}cm x {parseFloat(image?.dimensions?.height).toFixed(2)}cm
        </p>
      );
    };

    /**
     * Rendu des informations d'une image
     * @param image
     */
    const renderInfosImage = (image: GalleryFile) => {
      const classImg = image.isBatAuto ? "p-3 galeryInfoImg" : "p-1 galeryInfoImgAvantBatAuto";
      return (
        <div className={`border-top-0 ${classImg}`} style={{ background: '#f2f2f2', border: '1px solid #dee2e6' }}>
          {renderOrderDateAndNum(image)}
          {image?.dimensions && renderDimensions(image)}
        </div>
      );
    };

    const renderContainerImage = (image: GalleryFile) => {
      const classImg = image.isBatAuto ? "imgGallery" : "imgGalleryAvantBat";
      return (
        <div>
          <div className={`mr1 ${image.isBatAuto && props.isInterne ? '' : 'mb1'} p-2 ${classImg}`} style={{ border: '1px solid #dee2e6'}}
             id={image.name} key={image.name}
             onClick={event => selectFile(event, image)}>
            {renderImage(image)}
            {props.isInterne && renderInfosImage(image)}
          </div>
          {image.isBatAuto && props.isInterne &&
            <div onClick={event => selectFile(event, image, false)} className='text-center mr1 p-1 imgGallery small lightgrey'>Télécharger le TIFF</div>
          }
        </div>
      );
    };

    const renderLoader = () => {
      return (
        <div key={-1} className="text-center bold font16 p-1 w90 mx-auto">
          <div className="m-0 mt7 mt-5 border border-dark p-2">
            <div className="spinner mr-2">
              <div className="bounce1"></div>
              <div className="bounce2"></div>
              <div className="bounce3"></div>
            </div>
            <div className="bold">Chargement</div>
          </div>
        </div>
      );
    };

    const renderImages = () => {
      const tabImagesBatAuto = [];
      const tabImagesSansBatAuto = [];

      let displayUploadBatAuto = true;

      if (props.lstFilesBatAuto) {
        for (const image of props.lstFilesBatAuto) {
          tabImagesBatAuto.push(renderContainerImage(image));
        }
      } else {
        tabImagesBatAuto.push(renderLoader());
      }

      if (props.lstFilesSansBatAuto) {
        for (const image of props.lstFilesSansBatAuto) {
          tabImagesSansBatAuto.push(renderContainerImage(image));
        }
      } else {
        tabImagesSansBatAuto.push(renderLoader());
      }

      if (tabImagesBatAuto.length === 0) {
        displayUploadBatAuto = true;
      }

      return (
        <>
          <div className="d-flex row align-items-stretch justify-content-center  m-0">
            {displayUploadBatAuto && <UploadBtnByGallery identifier={props.infosUpload.identifier} onUpdateInput={props.infosUpload.onUpdateInput} selectedFileName={props.infosUpload.selectedFileName} authorizedFiles={props.infosUpload.authorizedFiles} marquageNom={props.infosUpload.marquageNom} surfaceId={props.infosUpload.surfaceId}/>}
            {tabImagesBatAuto}
          </div>
          {props.isInterne && tabImagesSansBatAuto.length > 0 && <div>
            <p className={"bold black text-uppercase my-2 font14"}><Icons icon="collections" size={20} color="#000"/> Visuels avant BAT Auto</p>
            <div className="d-flex row align-items-stretch justify-content-center m-0">
              {tabImagesSansBatAuto}
            </div>
          </div>}
        </>
      );
    };

    const alertNotBatAuto = () => {

      function onCloseAlert(downloadFile: boolean = true) {
        if(downloadFile) {
          onDownloadFile();
        }
        setDisplayAlert(false);
      }

      return (
        <Modal  classNames={{overlay: 'bootstrap-container'}} onClose={() => onCloseAlert(false)} open={displayAlert} showCloseIcon={false} center={true}>
          <p className={"text-center"}>Attention : Ce fichier a été récupéré d'une ancienne commande, un contrôle de votre part est impératif.<br/>
                                       Etes-vous sûr de vouloir télécharger ce fichier afin de le contrôler sur Photoshop ?</p>
          <div className={"d-flex justify-content-between"}>
            <button className={"flex-column flex-lg-row justify-content-center align-items-center btnBatAuto btnBatAutoPrimary  black cursor-pointer"} onClick={() => onCloseAlert(false)}>Annuler</button>
            <button className={"btnBatAuto cursor-pointer bold text-center py-2 px-4 btnBatAutoBat"} onClick={() => onCloseAlert(true)}>Valider</button>
          </div>
        </Modal>
      );
    }

    return (
      <div>
        {displayAlert && alertNotBatAuto()}
        {renderImages()}
      </div>
    );
}